import {
  addMilliseconds,
  formatISO,
  getHours,
  getMinutes,
  isAfter,
  parseISO,
  set,
} from 'date-fns';

import { getEventsCategories } from 'shared/constants';
import format from 'shared/lib/date-fns/format';
import i18n from 'shared/lib/i18n';

import { checkHasPermissions, isAdmin } from '../../utils';

import permissions from '../../permissions';

export const calculateStartsAt = (date, time) => {
  if (!date || !time) return null;

  const startDate = new Date(date);
  const startTime = new Date(time);

  const hours = getHours(startTime);
  const minutes = getMinutes(startTime);

  const startsAt = set(startDate, { hours, minutes });
  const startsAtISO = formatISO(startsAt);

  return startsAtISO;
};

export const calculateDuration = (start, end) => {
  if (!start || !end) return 0;

  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();

  const durationInMilliseconds = endTime - startTime;

  return durationInMilliseconds;
};

export const formatDateTimeRange = (isoDate, duration) => {
  const startTime = new Date(isoDate);
  const endTime = addMilliseconds(startTime, duration);

  const formattedStartDate = format(startTime, 'M/d/yy, h:mma');
  const formattedEndDate = format(endTime, 'h:mma');

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const formatDateTime = (isoDate) => {
  if (isoDate) {
    const date = new Date(isoDate);
    return format(date, "M/d/yy 'at' h:mm a");
  }
  return '';
};

export const findCategoryLabel = (value) => {
  const item = getEventsCategories().find((item) => item.value === value);
  return item.label;
};

export const parseCategoriesList = (list) =>
  list.map((category) => findCategoryLabel(category)).join(', ');

export const getDayOfWeek = (isoDate) => {
  if (isoDate) {
    const date = parseISO(isoDate);
    const dayOfWeek = format(date, 'EEEE');
    return dayOfWeek;
  }
  return '';
};

export const isDateValid = (isoDate, duration) => {
  const currentDate = new Date();
  const targetDate = parseISO(isoDate);
  const endDate = new Date(targetDate.getTime() + duration);

  return isAfter(endDate, currentDate);
};

export const composeGuests = (data) => {
  const results = [];

  data?.results?.forEach((item) => {
    const { id, attendee, guests } = item;

    results.push({
      id,
      ...attendee,
    });

    guests.forEach((guest) => {
      results.push({
        id: guest.id,
        fullName: guest.attendeeName,
      });
    });
  });

  return {
    ...data,
    results,
  };
};

export const isFile = (obj) =>
  obj !== null && typeof obj === 'object' && obj.constructor === File;

export const formatRsvpsForFilter = (data = []) =>
  data?.map((item) => ({
    value: item?.id,
    label: item?.attendee?.fullName,
  }));

export const formatResidentsForFilter = (data = []) =>
  data?.map((item) => ({
    value: item?.id,
    label: `${item?.firstName} ${item?.lastName}`,
  }));

export const checkCanUserEditEvent = (
  currentUserId,
  creatorId,
  startsAt,
  duration,
) => {
  const hasPermissions = checkHasPermissions(permissions.edit_social_event);
  const isPastEvent = isDateValid(startsAt, duration);

  if (isPastEvent)
    return isAdmin() || hasPermissions || currentUserId === creatorId;
  return false;
};

export const getEventsStatusTypes = () => [
  {
    label: i18n.t('events.upcomingEvents'),
    value: '1',
  },
  {
    label: i18n.t('events.pastEvents'),
    value: '0',
  },
];
